/*******************************************************************************
 * @ngdoc    object
 * @name     csm.books.data.BooksData.db.type:StoreItem
 * @constructor
 * @param {object=} item  StoreItem info from server.
 * @description
 * Row in StoreItems table.
 *******************************************************************************/
/* @ngInject */ export function RunStoreItem(BooksData) {
  BooksData.db.StoreItem = function (item) {
    return Object.assign(
      Object.create(BooksData.db.StoreItem.prototype),
      item || {}
    );
  };

  BooksData.db.StoreItem.prototype = {
    storeType: null, // Store Type.
    itemID: NaN, // Item ID.
    orgID: NaN, // Optional Org ID assignment.
    sort: NaN, // Sort Value.
    featured: false, // Featured Item.
    featureSort: NaN, // Feature Sort.
    name: null // Short Description.
  };
}
